import React, { useEffect } from "react";
import Modal from "../../Elements/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../State/Slices/modalSlice";
import styles from "../../Styles/Modules/Modal.module.scss";
import Button from "../../Elements/Button/Button";
import {
  checkSessionTime,
  reloadGame,
} from "../../State/Slices/gameSettingsSlice";

const SessionModal = () => {
  const dispatch = useDispatch();
  const { modalOpen } = useSelector((state) => state.modal);
  const { exp, sessionExpired, token } = useSelector((state) => state.game);

  useEffect(() => {
    if (exp > 0) {
      const timer = setTimeout(() => {
        dispatch(checkSessionTime());
      }, exp * 1000);

      return () => clearTimeout(timer);
    }
  }, [dispatch, exp, token]);

  useEffect(() => {
    if (sessionExpired) {
      dispatch(openModal("session"));
    }
  }, [dispatch, sessionExpired]);

  return (
    <div
      className={`${styles.modalOverlay} ${
        modalOpen === "session" ? styles.modalOverlayActive : ""
      }`}
    >
      <Modal
        name="session"
        modifier="modalSession"
        active={modalOpen}
        title="session_expired"
      >
        <Button
          text="reload"
          title="reload"
          modifier="buttonStandard"
          action={() => reloadGame()}
        />
      </Modal>
    </div>
  );
};

export default SessionModal;
